import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../auth.service';
import { MescModuleView, mescModules, mescUrl } from './config';
import { getEnv } from 'src/modules/utility';

@Component({
  selector: 'mesc',
  templateUrl: './mesc.component.html',
  styleUrls: ['./mesc.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class MESCComponent implements OnInit {
  moduleViews: MescModuleView[];
  private isLocal = true;

  constructor(
    public readonly router: Router,
    private readonly authService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.moduleViews = mescModules;
    this.isLocal = window.location.hostname.includes('localhost');
  }

  /**
   * 
   */
  validatePath = (path: string): boolean => this.authService.isClaimValid(path);


  /**
   * 
   */
  getEndpoint = (module): string => {
    let url =
      mescUrl[getEnv()]
        .replace("mesc-ui", "mesc-ui-" + module.title.toLowerCase())
        .replace("#/MESC", "#/" + module.title.toUpperCase());

    if (getEnv() !== 'PROD') {
      url = url.replace("mesc.", `${module.title.toLowerCase()}.`)
    } else if (module.title === 'PHF') {
      url = 'https://phf.opi.gm.com/#/PHF'
    }
    if (module.title.toUpperCase() === 'CTWR') {
      url = url.replace('test', 'test2');
    }

    return this.isLocal ?
      module.route : url;
  }

}
